module.exports = __webpack_public_path__ + "img/activity.eb5071dc.png";